// Order Management — Local UI Types

export type OrderTab = "pending" | "ongoing" | "completed" | "unprocessed" | "return";

export const ORDER_STATUS_MAP: Record<OrderTab, string> = {
  pending: "Pending",
  ongoing: "Ongoing",
  completed: "Completed",
  unprocessed: "Unprocessed",
  return: "Return",
};

export const TAB_LABELS: Record<OrderTab, string> = {
  pending: "Pending",
  ongoing: "Ongoing",
  completed: "Completed",
  unprocessed: "Unprocessed",
  return: "Return orders",
};

// Re-export global types for convenience
export type {
  AdminOrderListItem,
  OrderDetailsResponse,
  OrderProduct,
  PrescriptionItem,
  PrescriptionResponse,
  MedicineEntry,
  ReplacementEntry,
} from "../../services/api/admin-order.types";
